import * as cx from 'classnames'
import * as React from 'react'

import * as styles from './narrowEmptyItemCard.module.css'

interface IProps {
  viewType: string
}

class NarrowEmptyItemCard extends React.Component<IProps> {
  public render() {
    const { viewType } = this.props
    const rootClass = cx(styles.emptyItemCard, {
      [styles.gridView]: viewType === 'grid'
    })

    return <li role="presentation" aria-hidden="true" className={rootClass} />
  }
}

export default NarrowEmptyItemCard
